import React from "react";
import TableDataGrid from "./TableDataGrid";
import Box from "@mui/material/Box";
import Request from "../Utils/Request/Request";
import { useState, useContext, useEffect } from "react";
import { AppStorage } from "../Utils/Context/AppContext";
import { showToast } from "../Utils/index";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import ClientModal from "../modals/ClientModal";
import DeleteModal from "./DeleteModal";
import { FormControl, MenuItem, Select, TextField, Typography } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Loader from "./Loader";
import { useTranslation } from "react-i18next";

function AllClients() {
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [openDelModal, setOpenDelModal] = useState(false);

  const OpenDelModal = (user) => {
    setOpenDelModal(true);
    setDelClient(user);
  };

  const CloseDelModal = () => {
    setOpenDelModal(false);
  };

  const [delClient, setDelClient] = useState("");
  const [clients, setClients] = useState([]);
  const [clientToUpdate, setClientToUpdate] = useState(null);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 7,
  });
  const handleChange = (event, value) => {
    let dupPagination = { ...pagination };
    dupPagination.current = value;
    setPagination(dupPagination);
  };
  const [searchPhrase, setSearchPhrase] = useState("");

  const AppContext = useContext(AppStorage);

  useEffect(() => {
    if(AppContext?.userAuthToken || AppContext?.userAuthToken !== ""){
    getData({ pagination, searchPhrase });
    }
  }, [AppContext?.userAuthToken, pagination?.current, i18n.language]);
  
  useEffect(() => {
    if (forceUpdate) {
      getData({ pagination, searchPhrase });
    }
  }, [forceUpdate]);

  function getData(params) {
    setLoading(true);
    let paramsData = {};

    paramsData = {
      ...paramsData,
      searchPhrase: params.searchPhrase,
    };

    Request.get(`/getClients/${params.pagination?.current}`, paramsData
    )
      .then((result) => {
        setLoading(false);
        setClients(result.data["data"]);
        setForceUpdate(false);
        setPagination({
          ...params.pagination,
          total: result.data["totalCount"],
        });
        setSearchPhrase(params.searchPhrase);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }

  function searchChange(value) {
    getData({ pagination, searchPhrase: value });
  }
 // Function to recalculate row numbers
 const updateRowNumbers = () => {
  const clientsWithRowNumber = clients.map((client, index) => {
    return { ...client, rowNumber: (pagination.current - 1) * 7 + (index + 1) };
  });
  setClients(clientsWithRowNumber);
};

// Function to handle row deletion
const handleRowDelete = (selectedRowIds) => {
  const updatedClients = clients.filter(
    (client) => !selectedRowIds.includes(client.id)
  );
  setClients(updatedClients);
  updateRowNumbers(); // Recalculate row numbers after deletion
};
  const columns = [
    // { field: "id", headerName: "ID", width: 20 },
    { field: "rowNumber", headerName: `${t('SR-NO.')}`, width: 70 },
    { field: "email", headerName: `${t("Email")}`, width: 200 },
    { field: "companyName", headerName: `${t("Company Name")}`, width: 200 },
    { field: "companyNumber", headerName: `${t("Company Number")}`, width: 200 },
    { field: "phoneNumber", headerName: `${t("Phone Number")}`, width: 200 },
    { field: "vatNumber", headerName: `${t("Vat Number")}`, width: 200 },
    { field: "address", headerName: `${t("Address")}`, width: 200 },
    {
      headerName: `${t("Actions")}`,
      renderCell: (record) => {
        return (
          <Box sx={{ display: "flex", gap: "8px" }}>
            <EditIcon
              onClick={() => UpdateClientModal(record.row)}
              sx={{ cursor: "pointer", color: "#41c1ba" }}
            />
            <DeleteIcon
              sx={{ cursor: "pointer", color: "#365b6d" }}
              onClick={() => OpenDelModal(record.row)}
            />
          </Box>
        );
      },
    },
  ];

  function NewClientModal() {
    setOpen(true);
    setClientToUpdate(null);
  }

  function UpdateClientModal(client) {
    setOpen(true);
    setClientToUpdate(client);
  }

  function deleteClient(client) {
    Request.delete(`/delClient/${client["id"]}`)
      .then(() => {
        setForceUpdate(true);
        CloseDelModal();
        showToast("success", "Deleted Successfully.");
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }

  const changeLanguageHandler = (e) => {
    const languageValue = e.target.value
    i18n.changeLanguage(languageValue);

    localStorage.setItem("selectedLanguage", languageValue);
  }
  return (
    <Box className="portal-list-page">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: "8px",
        }}
      >
        <TextField
          type="text"
          placeholder={t("Search By Company")}
          onChange={(event) => searchChange(event.target.value)}
          sx={{
            width: "250px",
            marginRight: "20px",
            "& .MuiOutlinedInput-input": { height: "0.5em" },
            "& fieldset": {
              borderColor: "#365b6d !important",
            },
          }}
        />

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Button
        className="largeScreen-btn"
          onClick={NewClientModal}
          variant="contained"
          sx={{
            background: "#365b6d",
            "&:hover": { backgroundColor: "#365b6d" },
          }}
        >
        {t("Add New Client")}
        </Button>
        </Box>
        <Button
        className="smallScreen-btn"
          onClick={NewClientModal}
          variant="contained"
          sx={{
            background: "#365b6d",
            "&:hover": { backgroundColor: "#365b6d" },
            fontSize:"30px",
            height: "40px",
          }}
        >
          +
        </Button>
      </Box>
   
        <div className="portal-list-body">
          <Typography
            variant="h6"
            sx={{ color: "#365b6d", textAlign: "center" }}
          >
            {t("All Clients")}
          </Typography>
          {loading ? (
        <Loader />
      ) : (
        <>
          <TableDataGrid
            rows={clients.map((client, index) => ({ ...client, rowNumber: (pagination.current - 1) * 7 + (index + 1) }))}
            columns={columns}
            hideFooter
            disableColumnMenu
            checkboxSelection={false}
            disableSelectionOnClick
            onSelectionModelChange={(newSelection) => handleRowDelete(newSelection)}
            sx={{background:"white"}}
          />
          <Stack spacing={2} marginTop="5px">
            <Pagination
              count={Math.ceil(pagination?.total / 7)}
              page={pagination?.current}
              onChange={handleChange}
            />
          </Stack>
          </>
      )}
        </div>
      {open && (
        <ClientModal
          close={handleClose}
          open={open}
          handleClickOpen={handleClickOpen}
          client={clientToUpdate}
          setForceUpdate={setForceUpdate}
        />
      )}

      {openDelModal && (
        <DeleteModal
          del={deleteClient}
          currentUser={delClient}
          openDelModal={openDelModal}
          setDeleteModal={setOpenDelModal}
        />
      )}
    </Box>
  );
}

export default AllClients;
